module.exports = __webpack_public_path__ + "media/unauthenticated/signup-manager-2888d9eb.png";